import React, { Component } from "react";

import { getTodaysKioskSalesPerStation } from "../lib/dataQueries";
import { getStationId } from "../authProvider";

import SalesByKioskTodayChart from "../components/salesByKioskTodayChart";

class SalesByKioskTodayContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  async componentWillMount() {
    const stationId = getStationId();

    if (!stationId) {
      console.warn("Can't find stationid for sales query");
      return;
    }

    // Try twice as websocket can be slow to initialize
    try {
      await this.getData(stationId);
    } catch (e1) {
      try {
        await this.getData(stationId);
      } catch (e) {
        console.error("Error loading charts data");
      }
    }

    this.refresh = setInterval(() => this.getData(stationId), 30000);
  }

  componentWillUnmount() {
    clearInterval(this.refresh);
  }

  getData = async stationId => {
    try {
      const data = await getTodaysKioskSalesPerStation(stationId);
      this.setState({
        data,
      });
    } catch (e) {
      console.error("Error getting stats", e);
    }
  };

  render() {
    const { data } = this.state;

    if (!data || !data.length) return null;

    return <SalesByKioskTodayChart data={data} />;
  }
}

export default SalesByKioskTodayContainer;



// WEBPACK FOOTER //
// ./src/containers/salesByKioskTodayChart.js